import { Component, OnInit, inject } from '@angular/core';
import {Observable, zip} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {SignaalkaartService} from '../../../signaalkaart/signaalkaart.service';
import {Signaalkaart} from '../../../signaalkaart/signaalkaart';
import {map, mergeMap} from 'rxjs/operators';
import {VraagAntwoord} from '../../../signaalkaart/signaalkaart-antwoord';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {Location} from '@angular/common';
import {SignaalkaartAntwoordService} from '../../../signaalkaart/signaalkaart-antwoord.service';
import {NotificationService} from '../../../core/notification/notification.service';

@Component({
    templateUrl: './signaalkaart.page.html',
    styleUrls: ['./signaalkaart.page.scss'],
    standalone: false
})
export class SignaalkaartPage implements OnInit {
  private signaalkaartService = inject(SignaalkaartService);
  private signaalkaartAntwoordService = inject(SignaalkaartAntwoordService);
  private clientService = inject(ClientService);
  private notificationService = inject(NotificationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);

  signaalkaart$: Observable<Signaalkaart>;
  client$: Observable<Client>;
  dienstId$: Observable<string>;

  ngOnInit(): void {
    this.signaalkaart$ = zip(
      this.route.paramMap.pipe(map(paramMap => paramMap.get('signaalkaartId'))),
      this.signaalkaartService.getLaatsteVersieSignaalkaarten$(),
    )
      .pipe(map(([id, signaalkaarten]) => signaalkaarten.findSignaalkaartWithId(id)));
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('clientId')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
    this.dienstId$ = this.route.queryParamMap
      .pipe(
        map(queryParamMap => queryParamMap.get('dienstId'))
      );
  }

  navigateBack(): void {
    this.location.back();
  }

  // TODO: pass along the zone id by getting it from the dienst of the client for the selected dienst id
  bewaarSignaalkaartAntwoord([signaalkaartId, signaalkaartVersie, antwoorden]: [string, number, Array<VraagAntwoord>], clientId: string, dienstId: string): void {
    this.signaalkaartAntwoordService.postSignaalkaartAntwoord$(signaalkaartId, signaalkaartVersie, clientId, antwoorden, dienstId)
      .subscribe(_ => {
        this.notificationService.showSuccess(`Bedankt voor je melding. <br>Je dienst en therapeut worden op de hoogte gebracht.`);
        this.location.back();
      });
  }
}
